import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actionCreators as tipActions, tipPropTypes } from 'redux/tipHandlers';

import FieldDetail from './layout';

class FieldDetailContainer extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.style[1].visibility === 'visible' && this.props.style[1].visibility !== 'visible') {
      this.props.dispatch(tipActions.tipClicked(nextProps.rowData));
    }
  }

  onPressLike() {
    return () => this.props.dispatch(tipActions.tipToggleLike(this.props.rowData));
  }

  render() {
    const { style, rowData } = this.props;
    return <FieldDetail style={style} rowData={rowData} onClick={this.onPressLike()} />;
  }
}

FieldDetailContainer.propTypes = {
  rowData: PropTypes.shape(tipPropTypes).isRequired
};

export default connect()(FieldDetailContainer);
